import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const getDrexiSessionIdStarted = () => {
  return {
    type: actionTypes.GET_DREXI_SESSION_ID_STARTED,
  };
};

export const getDrexiSessionIdSuccess = (drexiOtp) => {
  return {
    type: actionTypes.GET_DREXI_SESSION_ID_SUCCESS,
    drexiOtp,
  };
};

export const getDrexiSessionIdFailed = (errorMessage) => {
  return {
    type: actionTypes.GET_DREXI_SESSION_ID_FAILED,
    errorMessage,
  };
};

export const getDrexiSessionId = (userId: string) => {
  return (dispatch) => {
    const userData={
      userId
    }
    dispatch(getDrexiSessionIdStarted());
    axios
      .post(serverconfigs.drexiSessionId,userData)
      .then((response) => {
        console.log(response.data);
        dispatch(getDrexiSessionIdSuccess(response.data.result.drexiOtp));
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(getDrexiSessionIdFailed(error.response.data.message));
      });
  };
};
